import React from 'react';
import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';

export const SEOSection = ({
  metaTitle,
  setMetaTitle,
  metaDescription,
  setMetaDescription,
  faqs,
  addFaq,
  updateFaq,
  removeFaq,
}) => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardContent className="p-6 space-y-6">
        <div>
          <Label>Meta Title</Label>
          <Input
            placeholder="SEO title"
            value={metaTitle}
            onChange={(e) => setMetaTitle(e.target.value)}
            maxLength={60}
            className="mt-2"
          />
          <p className="text-xs text-slate-500 mt-1">{metaTitle.length}/60 characters</p>
        </div>

        <div>
          <Label>Meta Description</Label>
          <Textarea
            placeholder="SEO description"
            value={metaDescription}
            onChange={(e) => setMetaDescription(e.target.value)}
            maxLength={160}
            rows={3}
            className="mt-2"
          />
          <p className="text-xs text-slate-500 mt-1">{metaDescription.length}/160 characters</p>
        </div>

        <div>
          <div className="flex items-center justify-between mb-3">
            <Label>FAQs</Label>
            <Button size="sm" variant="outline" onClick={addFaq}>
              <Plus className="h-3 w-3 mr-1" />
              Add FAQ
            </Button>
          </div>
          {faqs.map((faq) => (
            <Card key={faq.id} className="mb-3 border-slate-200">
              <CardContent className="p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium">FAQ</span>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => removeFaq(faq.id)}
                    className="h-7 w-7"
                  >
                    <X className="h-4 w-4" />
                  </Button>
                </div>
                <Input
                  placeholder="Question"
                  value={faq.question}
                  onChange={(e) => updateFaq(faq.id, 'question', e.target.value)}
                />
                <Textarea
                  placeholder="Answer"
                  value={faq.answer}
                  onChange={(e) => updateFaq(faq.id, 'answer', e.target.value)}
                  rows={2}
                />
              </CardContent>
            </Card>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};